import { observer } from "mobx-react-lite"
import { useState } from "react"
import { useHistory } from "react-router"
import { ANONYMOUS } from "../models/constants"
import { rootStore } from "../StApp"
import { navPaths } from "../stores/UIStore"
import { NavItem } from "./NavItem"

export const BottomNavBar = observer(() => {

    const [selectedIndex, setSelectedIndex] = useState(0)
    const history = useHistory()

    function navigate(index: number) {
        if(rootStore.mainStore.userName == ANONYMOUS)
         return
        setSelectedIndex(index)
        rootStore.uiStore.updateBottomNavIndex(index)
        history.replace(navPaths[index])
    }

    return (
        <div className='flex-row bottom-nav-bar-wrapper ' style={{display: rootStore.uiStore.appBarVisible? 'flex': 'none'}} >
            <div className='flex-row bottom-nav-bar' >
                {/* <NavItem key={0} icon='volume_up' index={0} callBack={navigate} label='VNotes' /> */}
                <NavItem key={0} icon='quickreply' index={0} callBack={navigate} label='Chats' />
                <NavItem key={2} icon='music_note' index={1} callBack={navigate} label='Jukebox'/>
                <NavItem key={1} icon='dashboard' index={2} callBack={navigate} label='Home' />
                <NavItem key={2} icon='favorite' index={3} callBack={navigate} label='Dateship'/>
            </div>
        </div>
    )

})